import api from './api';
import { API_ENDPOINTS } from '../config/api';
import { Ticket } from './bookingServiceAPI';

interface ValidateTicketResponse {
  success: boolean;
  valid: boolean;
  message: string;
  ticket?: {
    ticketNumber: number;
    type: string;
  };
  booking?: {
    bookingCode: string;
    customerName: string;
    eventDate: string;
  };
  usedAt?: string;
}

interface UseTicketResponse {
  success: boolean;
  message: string;
  ticket: {
    ticketNumber: number;
    type: string;
  };
  booking: {
    bookingCode: string;
    customerName: string;
  };
  stats: {
    totalTickets: number;
    usedTickets: number;
    remainingTickets: number;
  };
}

class TicketService {
  // Get tickets by booking ID
  async getTicketsByBooking(bookingId: string): Promise<{
    booking: any;
    tickets: Ticket[];
  }> {
    try {
      const response = await api.get(`${API_ENDPOINTS.TICKETS}/booking/${bookingId}`);
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'فشل جلب التذاكر');
    }
  }

  // Validate ticket
  async validateTicket(qrCode: string, bookingCode?: string): Promise<ValidateTicketResponse> {
    try {
      const response = await api.post(API_ENDPOINTS.VALIDATE_TICKET, { qrCode, bookingCode });
      return response.data;
    } catch (error: any) {
      if (error.response?.data) {
        return error.response.data;
      }
      throw new Error('فشل التحقق من التذكرة');
    }
  }

  // Use ticket
  async useTicket(qrCode: string, bookingCode?: string): Promise<UseTicketResponse> {
    try {
      const response = await api.post(API_ENDPOINTS.USE_TICKET, { qrCode, bookingCode });
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'فشل استخدام التذكرة');
    }
  }

  // Generate additional tickets
  async generateAdditionalTickets(
    bookingId: string, 
    count: number
  ): Promise<{ tickets: Ticket[] }> {
    try {
      const response = await api.post(
        `${API_ENDPOINTS.TICKETS}/generate/${bookingId}`,
        { count }
      );
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'فشل توليد التذاكر');
    }
  }
}

export const ticketService = new TicketService();